import React, {useContext} from 'react';
import { H6, Image, UL, LI, Btn, H5 } from '../../../../AbstractElements';
import SvgIcon from '../../../Common/Component/SvgIcon';
import { Card , CardBody, CardHeader } from 'reactstrap';
import CustomizerContext from '../../../../_helper/Customizer';

const MembersList = () => {

  const { layoutURL } = useContext(CustomizerContext);

  const userdata = JSON.parse(localStorage.getItem("userdata")??"{}");
  const membersdata = localStorage.getItem("members")??"[]";


  const memData = JSON.parse(membersdata);
  console.log(memData)

    const data = memData.filter((data)=> userdata?.user?.id!== data.id).map((row)  => ({
        name: `${row.first_name} ${row.surname}`,
        phone: row.phone,
        icon: 'fill-chat',
        dob: row.dob,
        color: 'primary',
        row: row
        
    }))
    // ,{
    //     name: 'UserName',
    //     phone: '9874561230',
    //     icon: 'fill-chat',
    //     dob: '07/07/2024',
    //     color: 'primary',
        
    // }
  // ]
  const handleSwitchUser = (mem) => {
    console.log(mem)
    localStorage.setItem('userdata', JSON.stringify({ "user": mem }));
    localStorage.setItem('role_id', mem.role_id);

    function redirectToDefaultPage() {
      window.location.href = `${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`;
    }

    // ...

    setTimeout(redirectToDefaultPage, 50);
  }
  

 
  return (
    <>
    <Card className='schedule-card'>
    <CardHeader className='card-no-border'>
    <div className='header-top'>
    <H5 attrH5={{ className: 'm-0' }}>{"Family Members"} </H5>
    <span className='text-muted'>Note: Click to Switch User</span>
    </div>
         </CardHeader>
         <CardBody className='pt-0'>
    <UL attrUL={{ className: 'schedule-list' }}>
      {data.map((item, i) => (
        <LI key={i} attrLI={{ className: `${item.color} d-flex flex-column justify-content-start align-items-start mb-3`}}>
          <div onClick={()=> handleSwitchUser(item.row)} style={{cursor: 'pointer'}}>
          {/* <Image attrImage={{ src: require(`../../../assets/images/dashboard/user/${item.image}`), alt: 'profile' }} /> */}
            <H6 className='mb-1'>{item.name}</H6>
            <UL>
              <LI attrLI={{ className: 'f-light' }}>
                <SvgIcon iconId={item.icon} className='fill-icon f-light' />
                <span>{item.phone}</span>
              </LI>
              <LI attrLI={{ className: 'f-light' }}>
                {/* <SvgIcon iconId={item.icon2} className='fill-icon f-success' /> */}
                <span> {item.dob}</span>
              </LI>
            </UL>
        </div>
        </LI>
      ))}
    </UL>
    </CardBody>
    </Card>
    </>
  );
};

export default MembersList;
